import React from 'react';
import { Layout, Typography, Row, Col, Tag, Grid, Badge } from 'antd';
import { useTranslation } from 'react-i18next';
import { getCurrentUser } from '../utils/userStorage';
import FAQ from '../components/FAQ';
import StripePricingTable from '../components/subscription/StripePricingTable';
import SocialProof from '../components/subscription/SocialProof';
import TestimonialWidget from '../components/subscription/TestimonialWidget';
import BackLink from '../components/BackLink';
import FinalCTA from '../components/subscription/FinalCTA';
import ClimatePledgeCard from '../components/subscription/ClimatePledgeCard';

const { Content } = Layout;
const { Title, Text } = Typography;

const PricingPill = ({ translationKey }) => {
  const { t } = useTranslation();

  return (
    <Tag 
      style={{
        fontSize: '17px',
        fontWeight: '600',
        padding: '10px 18px',
        margin: '0 8px',
        borderRadius: '20px',
        border: '1px solid rgba(156, 39, 176, 0.2)',
        background: 'linear-gradient(135deg, #e3f2fd 0%, #f3e5f5 100%)',
        color: '#37474f',
        boxShadow: '0 4px 12px rgba(227, 242, 253, 0.4)',
        transition: 'all 0.3s ease',
        textShadow: 'none',
        letterSpacing: '0.3px',
        lineHeight: '1.4',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '40px'
      }}

    >
      {t(translationKey)}
    </Tag>
  );
};

const Pricing = () => {
  const { t } = useTranslation();
  let currentUser;
  try {
    currentUser = getCurrentUser();
  } catch (error) {
    console.error('Error getting current user:', error);
    currentUser = null;
  }
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const isMobile = !screens.md;

  return (
    <Content className="page pricing-page">
      {isMobile && (
        <Row align="middle" gutter={[16, 16]} style={{ marginBottom: '8px', marginLeft: '0px' }}>
          <Col flex="none" style={{ textAlign: 'left', paddingLeft: 0 }}>
            <BackLink to="/" label={t('common.back')} />
          </Col>
        </Row>
      )}
      <Row justify="center" style={{ 
        marginBottom: '30px',
        padding: '20px 16px'
      }}>
        <Col xs={24} sm={22} md={18} lg={16}>
          <Title 
            level={isMobile ? 2 : 1} 
            style={{ 
              fontWeight: '600',
              textAlign: 'center',
              marginBottom: '16px',
              color: '#1a1a1a',
              lineHeight: isMobile ? '1.3' : '1.2',
              letterSpacing: '-0.02em',
              fontSize: isMobile ? '28px' : '36px'
            }}
          >
            {t('pricing.title')}
          </Title>
          <Title 
            level={isMobile ? 5 : 4} 
            style={{ 
              marginBottom: '-10px',
              fontWeight: '500',
              textAlign: 'center',
              color: '#666',
              lineHeight: '1.5',
              opacity: 0.9,
              fontSize: isMobile ? '16px' : '22px'
            }}
          >
            {t('pricing.subtitle')}
          </Title>
        </Col>
      </Row>
      <StripePricingTable customerEmail={currentUser?.email} />

      <TestimonialWidget />

      <SocialProof />
      
      <div style={{ textAlign: 'center', marginTop: '50px', marginBottom: '0px' }}>
        <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: '18px' }}>
          {[1, 2, 3].map((index) => (
            <PricingPill 
              key={index}
              translationKey={`pricing.pills.pill${index}`} 
            />
          ))}
        </div>
      </div>

      <div style={{ marginTop: 40 }}>
        <FAQ localeKey={"faq_pricing"}/>
      </div>

      <FinalCTA />
            
      <ClimatePledgeCard />

      
      {isMobile && (
        <Row style={{ marginTop: '8px' }}>
          <Col style={{ textAlign: 'left' }}>
            <BackLink to="/" label={t('common.back')} />
          </Col>
        </Row>
      )}
    </Content>
  );
};

export default Pricing; 